var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_172_76159)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.01184 16C7.65663 16 7.30143 15.8658 7.03305 15.5974L0.402565 8.96695C0.142082 8.70646 0 8.35915 0 7.98816C0 7.62506 0.142082 7.26986 0.402565 7.00937L7.00937 0.402565C7.54613 -0.134188 8.4223 -0.134188 8.95905 0.402565C9.49581 0.939319 9.49581 1.81549 8.95905 2.35224L3.32314 7.98816L8.97484 13.6399C9.51159 14.1766 9.51159 15.0528 8.97484 15.5895C8.71436 15.8658 8.36704 16 8.01184 16Z",
    fill: "#3A3A3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6211 9.4562H2.99162C2.12334 9.4562 1.41293 8.74579 1.41293 7.87752C1.41293 7.00924 2.12334 6.29883 2.99162 6.29883H15.6211C16.4894 6.29883 17.1998 7.00924 17.1998 7.87752C17.1998 8.74579 16.4973 9.4562 15.6211 9.4562Z",
    fill: "#3A3A3A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_172_76159"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.1998,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow-back.f6cd5022295c5a34e4cb73b8adc193ed.svg";
export { ForwardRef as ReactComponent };